import * as React from 'react';
import { useActions } from '../viewModalActions';
import { getSchema } from '../../../utils';
import { ModalGroup, ModalGroups } from '../../ModalGroup/modalGroup';
import { useSelector } from '../../../utils/useSelector';
import { MultiSort } from '../../MultiSort/multiSort';

export const PageSort = () => {
  const selectedWorkspace = useSelector(s => s.planning?.selectedWorkspace);
  const fields = useSelector(s => s.viewModal?.fields);
  const sortBy = useSelector(s => s.viewModal?.sortBy);
  const data = useSelector(s => s.viewModal?.data);
  const { setViewSetting } = useActions();
  if (!selectedWorkspace) return null;
  const { schemas } = selectedWorkspace;
  const dataSchema = getSchema(schemas, data);
  const parentFields = sortBy?.filter(s => s.isFromParent)?.map(s => s.field);

  return (
    <ModalGroups>
      <ModalGroup label="Default Sort Criteria">
        <MultiSort
          viewFields={fields}
          dataSchema={dataSchema}
          disabledFields={parentFields}
          sortBy={sortBy}
          setSortBy={sortBy => setViewSetting({ sortBy })}
        />
      </ModalGroup>
    </ModalGroups>
  );
};
